/* eslint-disable no-unused-expressions */
import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import GlobalForm from "../../../components/globalForm/GlobalForm";
import Loading from "../../../components/shared/loading/Loading";
import { updateData } from "../../../hooks/update";
import useFetch from "../../../hooks/useFetch";
import { apiPath, RoutePath } from "../../../utility/Constant";

const CareerUniquePage = () => {
  const { careersApi } = apiPath;
  const [uniqueData, uniqueLoading] = useFetch(careersApi);
  const [filteredData, setFilteredData] = useState();
  let { id } = useParams();
  const { aboutUsCareerList } = RoutePath;


  useEffect(() => {
    setFilteredData(uniqueData?.filter((item) => item._id === id)[0]);
  }, [uniqueData, id]);

  if (uniqueLoading || !filteredData?._id) {
    return <Loading />;
  }

  const { sub_title, title, description, date, detail_title, status, _id } =
    filteredData ?? {};

  const data = [
    {
      elementType: "input",
      label: "title",
      type: "Text",
      name: "title",
      defaultValue: title,
      required: false,
    },
    {
      elementType: "input",
      label: "detail title",
      type: "Text",
      name: "detail_title",
      defaultValue: detail_title,
      required: false,
    },
    {
      elementType: "input",
      label: "sub title",
      type: "Text",
      name: "sub_title",
      defaultValue: sub_title,
      required: false,
    },
    {
      elementType: "input",
      label: "date",
      type: "date",
      name: "date",
      defaultValue: date,
      required: false,
    },
    {
      elementType: "textField",
      label: "description",
      type: "Text",
      name: "description",
      defaultValue: description,
      required: false,
    },
    {
      elementType: "select",
      label: "Job Status",
      type: "select",
      name: "status",
      options: ["active", "hired", "hidden"],
      defaultValue: status,
      required: false,
    },
  ];

  const update = (data) => {
    updateData(careersApi, data, _id);
    setTimeout(() => {
      window.location.href = "/" + aboutUsCareerList;
    }, 800);
  };

  return (
    <div>
      <GlobalForm data={data} update={update} />
    </div>
  );
};

export default CareerUniquePage;
